"use client";

import { DepictOptions } from "@/lib/depict/types";
import {
  DepictProductResponse_internal,
  getDepictProducts,
} from "@/lib/hooks/useProductFilter/getProducts";
import {
  HeroSectionStoryblok,
  SideBySideStoryblok,
  TaggedImageSideBySideStoryblok,
} from "@/types/storyblok-blok-types";
import { GetListingResponse } from "@depict-ai/types/api/GetListingResponse";
import { keepPreviousData, useInfiniteQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import PlpModals from "../PlpModals";
import ProductsSection from "../ProductsSection/ProductsSection";

export const DepictPlp = ({
  initialProductData,
  listingPage,
  options,
  bloks,
}: {
  initialProductData: DepictProductResponse_internal;
  listingPage: GetListingResponse | null;
  options: DepictOptions;
  bloks:
    | (
        | TaggedImageSideBySideStoryblok
        | SideBySideStoryblok
        | HeroSectionStoryblok
      )[]
    | undefined;
}) => {
  const { data, fetchNextPage, hasNextPage } = useInfiniteQuery({
    queryKey: ["products", { ...options }],
    queryFn: ({ pageParam }) => {
      return getDepictProducts(
        {
          ...options,
          query: options.query,
        },
        pageParam
      );
    },
    initialData: {
      pages: [initialProductData],
      pageParams: [null as string | null],
    },
    initialPageParam: null,
    getNextPageParam: (lastPage) => {
      return lastPage?.nextCursor ?? undefined;
    },
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
  });

  const plpContent = useMemo(() => {
    return data?.pages?.flatMap((page) => page?.products) || [];
  }, [data]);

  const fetchNext = async () => {
    fetchNextPage();
  };
  return (
    <>
      <PlpModals
        search={""}
        filters={initialProductData?.filters}
        sort={initialProductData?.sorts}
      />
      <ProductsSection
        data={{
          plpContent,
          listingPage,
          fetchNextPage: fetchNext,
          /*     isFetching, */
          hasNextPage,
        }}
      />
    </>
  );
};
